/* eslint-disable */
// GENERATED by scripts/generate-aws-exports.mjs - do not edit, do not commit.
// Source: config/customers/windward.json plus REACT_APP_COGNITO_* env vars.
const awsmobile = {
  "aws_project_region": "us-east-1",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_esuCKPxuT",
  "aws_user_pools_web_client_id": "6o5lp9rfdhcq4ii7bla928va1i",
  "aws_cognito_username_attributes": [],
  "oauth": {
    "domain": "windward-login.auth.us-east-1.amazoncognito.com",
    "scope": [
      "openid",
      "email",
      "profile",
      "aws.cognito.signin.user.admin"
    ],
    "redirectSignIn": "",
    "redirectSignOut": "",
    "responseType": "code"
  },
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [
    "EMAIL"
  ],
  "aws_cognito_mfa_configuration": "OPTIONAL",
  "aws_cognito_mfa_types": [
    "TOTP"
  ],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": [
      "REQUIRES_NUMBERS",
      "REQUIRES_SYMBOLS"
    ]
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ]
};

export default awsmobile;
